<template>
  <v-dialog
    persistent
    v-model="subscriptionAddFreeModal"
    content-class="addfreebox"
  >
    <v-card>
      <!-- <loader v-if="showLoader"></loader> -->
      <v-card-title class="headline grey lighten-2">
        Add Free Trial
        <div class="spacer"></div>
        <!-- <CButtonClose @click.stop="$emit('close')" /> -->
      </v-card-title>
      <v-card-text>
        <CRow>
          <CCol sm="12" md="12">
            <CCol
              sm="12"
              md="12"
              class="pt-0"
              v-if="
                role === 'doctor' ||
                (role !== 'doctor' && userSubscriptionData.all_center_expired)
              "
            >
              <label for>No of days</label>
              <input
                v-model="days"
                class="form-control"
                label="Search"
                placeholder="10"
                type="number"
              />
              <small v-if="showError" class="text-danger">
                This field is required</small
              >
            </CCol>
            <CCol sm="12" md="12" class="pt-0" v-else>
              <label for>Select Plan</label>
              <CCol
                sm="12"
                md="12"
                class="pt-0"
                v-for="plan in visiblePlans"
                :key="plan._id"
              >
                <p>{{ plan.settings.plan_name }}</p>
                <div
                  v-for="charge in plan.visibleCharges"
                  :key="charge._id"
                >
                  <p>{{ charge.name }}</p>
                  <v-btn
                    class="btn btn-success"
                    @click="assignFreeTrial(null, plan._id, charge._id)"
                    >Assign</v-btn
                  >
                </div>
              </CCol>
            </CCol>
          </CCol>

          <CCol sm="12" class="pl-0 pr-0">
            <div class="text-right">
              <v-btn depressed @click.stop="$emit('close')" color="error mr-2">
                Cancel
              </v-btn>
              <v-btn
                :loading="showLoader"
                depressed
                @click="addFreeTrial()"
                color="success"
                v-if="
                  role === 'doctor' ||
                  (role !== 'doctor' && userSubscriptionData.all_center_expired)
                "
              >
                Submit
              </v-btn>
            </div>
          </CCol>

          <!-- this filter for active user page end -->
        </CRow>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import config from "@/config.js";
import Swal from "sweetalert2";
export default {
  props: [
    "subscriptionAddFreeModal",
    "userSubscriptionData",
    "role",
    "planList",
  ],
  data() {
    return {
      days: "",
      showLoader: false,
      showError: false,
    };
  },
  computed: {
    // Replaces v-if on v-for to satisfy vue/no-use-v-if-with-v-for lint rule.
    // Only plans marked show_on_frontend are shown; each plan carries a
    // pre-filtered visibleCharges array so the inner loop needs no v-if either.
    visiblePlans() {
      return (this.planList || [])
        .filter((plan) => plan.settings.show_on_frontend)
        .map((plan) => ({
          ...plan,
          visibleCharges: (plan.settings.charges || []).filter(
            (charge) => charge.show_on_admin_frontend
          ),
        }));
    },
  },
  methods: {
    addFreeTrial() {
      this.validateDays(this.days);
      if (!this.showError) {
        this.assignFreeTrial(this.days);
      }
    },

    assignFreeTrial(days, subscriptionId = null, chargeId = null) {
      this.showLoader = true;
      let obj = {
        role: this.role,
        user_id: this.userSubscriptionData.user_id,
        center_id: this.userSubscriptionData.center_id,
        days: days,
        subscription_id: subscriptionId,
        charge_id: chargeId,
        // Bug fix: user_subscription is null for brand-new centers that have
        // never had any subscription — guard the _id access to avoid a crash.
        user_subscription_id: this.userSubscriptionData.user_subscription
          ? this.userSubscriptionData.user_subscription._id
          : null,
      };
      let url = `${config.BASE_URL}api/v2/admin/subscription/assign-extended`;
      this.$http
        .post(url, obj)
        .then((response) => {
          if (response.body.status) {
            this.showLoader = false;
            this.$emit("close");
            Swal.fire(response.body.message);
            this.$emit("refreshList");
          } else {
            this.showLoader = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.showLoader = false;
          this.$emit("close");
        });
    },

    validateDays(newValue) {
      if (newValue === "") {
        this.showError = true;
      } else {
        this.showError = false;
      }
    },
  },

  watch: {
    days: function (newValue) {
      this.validateDays(newValue);
    },
  },
};
</script>